import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'

const path = '/le-connect/contests/{id}/isAllWinnersAwarded'
const method = 'put'

interface UsePutSweepstakeParams {
  sweepstakeId: number
  onSuccess?: () => void
  onError?: () => void
}

export const usePutSweepstakeIfAllWinnersAwarded = ({
  sweepstakeId,
  onSuccess,
  onError,
}: UsePutSweepstakeParams) => {
  const queryClient = useQueryClient()
  const put = useTypedApiClient({ path, method })
  const mutate = useMutation({
    mutationKey: ['/contests/{id}/isAllWinnersAwarded', sweepstakeId],
    mutationFn: async () => {
      const { data } = await put({ id: sweepstakeId })
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['/sweepstakes/by-id', sweepstakeId],
      })
      await queryClient.invalidateQueries({
        queryKey: ['/sweepstakes/drawing-info', sweepstakeId],
      })
      await queryClient.invalidateQueries({
        queryKey: ['/sweepstakes/drawing-info/multi-draw', sweepstakeId],
      })
      await queryClient.invalidateQueries({
        queryKey: ['/sweepstakes', sweepstakeId],
      })
      onSuccess?.()
    },
    onError,
  })

  return mutate
}
